__turbopack_context__.v({
  "brandLink": "SiteTopNav-module-scss-module__wKFkTW__brandLink",
  "headerDocs": "SiteTopNav-module-scss-module__wKFkTW__headerDocs",
  "headerHome": "SiteTopNav-module-scss-module__wKFkTW__headerHome",
  "homeCta": "SiteTopNav-module-scss-module__wKFkTW__homeCta",
  "homeFrame": "SiteTopNav-module-scss-module__wKFkTW__homeFrame",
  "homeLogoCell": "SiteTopNav-module-scss-module__wKFkTW__homeLogoCell",
  "homeMainCell": "SiteTopNav-module-scss-module__wKFkTW__homeMainCell",
  "homeNavDesktop": "SiteTopNav-module-scss-module__wKFkTW__homeNavDesktop",
  "homeRow": "SiteTopNav-module-scss-module__wKFkTW__homeRow",
  "homeUtilities": "SiteTopNav-module-scss-module__wKFkTW__homeUtilities",
  "homeUtilsCell": "SiteTopNav-module-scss-module__wKFkTW__homeUtilsCell",
  "logoCell": "SiteTopNav-module-scss-module__wKFkTW__logoCell",
  "mainCell": "SiteTopNav-module-scss-module__wKFkTW__mainCell",
  "mainMenuTrigger": "SiteTopNav-module-scss-module__wKFkTW__mainMenuTrigger",
  "mainNavLinks": "SiteTopNav-module-scss-module__wKFkTW__mainNavLinks",
  "row": "SiteTopNav-module-scss-module__wKFkTW__row",
  "utilsCell": "SiteTopNav-module-scss-module__wKFkTW__utilsCell",
  "utilsDesktop": "SiteTopNav-module-scss-module__wKFkTW__utilsDesktop",
  "utilsMobile": "SiteTopNav-module-scss-module__wKFkTW__utilsMobile",
  "wordmarkHome": "SiteTopNav-module-scss-module__wKFkTW__wordmarkHome",
});
